import { KolInputText } from '@public-ui/react-v19';
import type { FC } from 'react';
import React from 'react';
import { SampleBlock } from '../SampleBlock';
import { SampleDescription } from '../SampleDescription';

export const InputTextCounter: FC = () => (
	<>
		<SampleDescription>
			<p>This story showcases an input with a counter for the chars in the field. Maximal length is 30.</p>
		</SampleDescription>

		<SampleBlock id="counter">
			<KolInputText _label="Name" _icons="kolicon-house" _value="Anderson-Clark" _hasCounter _maxLength={30} />
		</SampleBlock>
	</>
);
